import simbApi from ".";
import { GET_LATEST_COLUMN_VALUES } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

export const fetchLatestColumnValuesResynchronization = async (access_token: string, columns: any) => {
  try {
    const response = await simbApi.post(
      GET_LATEST_COLUMN_VALUES,
      {
        columns,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    if (response?.data?.error) {
      throw new Error(response?.data?.error);
    }

    return response?.data?.data;
  } catch (error: any) {
    logger.error("Error fetching latest column values:", error);
    throw error;
  }
};
